import domain from "./DomainService";

/**
 * Handle login
 *
 * @param {string} inputEmail user's email
 * @param {string} inputPassword user's pass
 * @return {Promise}
 */
export default function LoginService({ email, password, accessToken }) {
  const options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
    },
    body: JSON.stringify({ email, password, accessToken }),
  };

  return fetch(domain() + "api-token-auth/", options);
}
